var mobileWidth = 750;
let viewportHadChanged = $(window).width() < 750;
$(function() {
	viewportHadChanged = $(window).width() < 750;
	/********** Product Description **********/
	loadTabImages();
	loadDescriptionIcons();
	setTimeout(function() {
		resizeProdImages();
	}, 1000);

  $('.jdgm-rev-widg__reviews').slick({
    slidesToShow: 1,
    infinite: true,
    dots: true,
    arrows:false

  });

  $('.template-product').on('click','.product-tab-group', function(e) {
	let nthDiv = $(this).data('tab');
	let $group = $('.product-tab-group[data-tab="' + nthDiv + '"]');
	
	
	if($(window).width() <= mobileWidth) {
		$group
			.toggleClass('active')
			.siblings('.product-tab-group');
	} else {
		$group
			.addClass('active')
			.siblings('.product-tab-group:not([data-tab="' + nthDiv + '"])')
			.removeClass('active');
	}
		
	});

  /********** Product Reviews Pagination **********/
	$('.template-product').on('click','.spr-pagination-page, .spr-pagination-next, .spr-pagination-prev, .spr-summary-actions', function(e) {
		if ($(e.target).closest('a').length == 0) {
			$(this)
				.find('a')[0]
				.click();
		}
	});
	setTimeout(function() {
		if(!$('.spr-pagination').is(":visible")) {
			$('body').addClass('no-pagination');
		}
	  }, 2500);
	$('.template-product').on('click','.spr-summary-actions', function(e) {
		let $form = $('.spr-form','.template-product');
		let $reviews = $('.spr-reviews','.template-product');
		let $button = $(this);
		let $subheading = $('.spr-summary-caption','.template-product');
		let $container = $('html');
		let $reviewContainer = $('#shopify-product-reviews');

		if ($form.is(':visible')) {
			$button
				.find('a')
				.text('READ REVIEWS');
			$subheading.hide();
			$reviews.hide();
			$container.addClass('form-visible');
			if ($reviewContainer.hasClass('empty')) {
				$reviewContainer
					.removeClass('empty')
					.attr('data-empty','empty');
			}
		} else {
			$button
				.find('a')
				.text('WRITE A REVIEW');
			$subheading.show();
			$reviews.show();
			$container.removeClass('form-visible');
			if ($reviewContainer.data('empty') == 'empty') {
				$reviewContainer.addClass('empty');
			}
		}
	});

	/********** Social Sharing **********/
	$('.template-article').on('click','.share-mail', function(e) {
		$('.template-article')
			.find('.st-btn')
			.trigger('click');
	});

	/********** Blog Filter **********/
	$('.tags-dropdown').on('change', function() {
		var optionVal = $(this).val();
		$('.tags .tag_' + optionVal)
			.find('a')[0]
			.click();
	});
	if($(window).width() < 750){
		setTimeout(()=>{$('.disable-transition-on-load').removeClass('disable-transition-on-load')}, 300);
		changeToMobile();
	}
	
}); //end of onready

/********** Functions **********/

// Functions on resize
$(window).resize(
  $.debounce(50, function() {
		resizeProdImages();
		if(viewportHadChanged != ($(window).width() < 750) ){
			if ($(window).width() >= 750) {
				changedToDesktop();
			}
			else{
				changeToMobile();
			}
			viewportHadChanged = $(window).width() < 750;
		}
  })
);
function changeToMobile() {
	const activeTab = $('.product-tab-wrapper .product-tab-group.product-tab.active');
	activeTab.each(function(){
		$(this).click();
	});
}
// function to trigger from desktop to mobile
function changedToDesktop() {
	const activeTab = $('.product-tab-wrapper .product-tab-group.product-tab.active');
	
	const firstTab = $('.product-tab-wrapper .product-tab-group.product-tab').first();
	if(activeTab.length != 1){
		activeTab.each(function(){
			// console.log("count")
			$(this).click();
		});
		firstTab.click();
	}
}

//Load tab images using link from metafields
function loadTabImages() {
	const $imgContainers =  $('.product-description td:first-child','.template-product');
	$imgContainers.each(function(e) {
		let imgLink = $(this).text();
		let img = '';

		//confirm if src link is present
		if (imgLink.indexOf('files') >= 0) {
			img = '<img src="'+ imgLink +'" />';
			$(this)
				.text('')
				.append(img);
		}
	});
}

//Find icons container on product description and add flex class
function loadDescriptionIcons() {
	const $imgs=  $('.meta-product-description img','.template-product');
	$imgs.each(function(e) {
		let $imgContainer = $(this).closest('p');
		$imgContainer.addClass('img-flex-container');
	});
}

function resizeProdImages() {
	if ($(window).width() < 750) {
		var totalHeight = 0;
		$('.product-card__image img','.template-product').each(function(e) {
			totalHeight += $(this).height();
		});
	
		var avgHeight = (totalHeight / $('.product-card__image img','.template-product').length) + 'px';
		var avgHeightAdjusted = (totalHeight / $('.product-card__image img','.template-product').length) + 75 + 'px';

		$('.product-card__image img','.template-product').each(function(e) {
			$(this).css({'max-height':avgHeight, 'bottom':0, 'width':'auto', 'object-fit':'contain', 'margin':'auto'});
			var $imgWrapper = $(this).closest('.img-wrapper');
			$imgWrapper
				.closest('.img-wrapper')
				.css('padding-top', avgHeight)
				.closest('.product-card')
				.find('.product-card__info')
				.addClass('test')
				.css('top', avgHeightAdjusted);
		});
	}
}